var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productDetail-box"},[_c('div',[(_vm.details)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.details)}})]:_c('div',{staticClass:"nodata"},[_c('nothing',{attrs:{"customClass":"px-0","top":"237px","text":_vm.getText}})],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }